import { appConfig, pad } from "../../../utils";

export const addSafetyObjectiveRegisterForm = ({ form, store, router, db }) => {
    const nextRevision = 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setConfig({
        "title": "Add Safety Objective Register Form",
        "type": "push",
        "location": "SafetyManagement/SafetyObjectiveRegister",
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                
                
                return `${appConfig.docPrefix}SOR-${pad(store.state.counts.safeobj.count)}`
            }
        }, {
            "label": "Title",
            "name": "Title",
            "type": "text",
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async preSubmitHook({ db }) {
            const number = await db.utils.allocateCount("counts/safeobj/count");
            return {
                "Number": `${appConfig.docPrefix}SOR-${pad(number)}`,
            }
        },
        async postSubmitHook({ files, typeRef }) {
            for (const file of files) {
                await db.upload(`Database/SafetyObjectiveRegister/${typeRef.key}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/SafetyObjectiveRegister/${typeRef.key}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "By": store.state.user.Basic.name,
                    "Date": new Date().toISOString(),
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};

export const reviseSafetyObjectiveRegister = ({ form, pageItem, store, db }) => {
    const nextRevision = parseInt(pageItem.Revision) + 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setValues(pageItem);
    form.setConfig({
        "title": "Revise Safety Objective Register Form",
        "type": "update",
        "location": `SafetyManagement/SafetyObjectiveRegister/${pageItem.ID}`,
        "fields": [{
            "label": "Next Revision",
            "type": "value",
            value() {
                return nextRevision;
            }
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async postSubmitHook({ files }) {
            for (const file of files) {
                await db.upload(`Database/SafetyObjectiveRegister/${pageItem.ID}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/SafetyObjectiveRegister/${pageItem.ID}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "Date": new Date().toISOString(),
                    "By": store.state.user.Basic.name,
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};
